/**
 * Class strings shared by the landing arms, so every arm's CTAs look the same
 * and a change to the brand button reaches all of them at once.
 */

export const focusRing =
  "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-signal dark:focus-visible:outline-signal-text";

// Square corners on CTAs and chips — the prototypes' pill shapes are traded
// for the site's marketing language (cf. SiteNav / pricing-page buttons).
export const ctaButton = `inline-flex items-center justify-center rounded-none bg-signal px-8 py-4 text-[1.02rem] font-semibold text-cream transition hover:bg-signal-deep hover:shadow-[0_10px_30px_-10px_rgba(var(--signal-rgb),0.45)] ${focusRing} focus-visible:outline-cream`;

/** Small accent text that must pass 4.5:1 in both themes. */
export const accentText = "text-signal dark:text-signal-text";
